/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContainerDto } from './ContainerDto';
import type { DeliveryOrderDto } from './DeliveryOrderDto';
import type { DispatchDeliveryOrderStageDto } from './DispatchDeliveryOrderStageDto';
import type { EquipmentDto } from './EquipmentDto';
export type DispatchDeliveryOrderResponseDto = {
    autoIndicator?: boolean;
    cargoCutoffDate?: string;
    container?: ContainerDto;
    containerTypeId?: string;
    daysOut?: number;
    deliveryOrder?: DeliveryOrderDto;
    deliveryPlannedAppointmentDateConfirmed?: boolean;
    deliveryStage?: DispatchDeliveryOrderStageDto;
    equipment?: EquipmentDto;
    hazmatId?: string;
    hazmatIndicator?: boolean;
    id?: string;
    loadType?: DispatchDeliveryOrderResponseDto.loadType;
    number?: string;
    overweightIndicator?: boolean;
    pickupStage?: DispatchDeliveryOrderStageDto;
    returnStage?: DispatchDeliveryOrderStageDto;
    status?: DispatchDeliveryOrderResponseDto.status;
    updatedAt?: string;
};
export namespace DispatchDeliveryOrderResponseDto {
    export enum loadType {
        LIVE_LOAD = 'LIVE_LOAD',
        DROP_AND_PICK = 'DROP_AND_PICK',
    }
    export enum status {
        NEW = 'NEW',
        NEW_ACCEPTED = 'NEW_ACCEPTED',
        NEW_REJECTED = 'NEW_REJECTED',
        HOLD_LOADED = 'HOLD_LOADED',
        HOLD_ARRIVED = 'HOLD_ARRIVED',
        HOLD_UNLOADED = 'HOLD_UNLOADED',
        NOT_ON_FILE = 'NOT_ON_FILE',
        RELEASED_LOADED = 'RELEASED_LOADED',
        RELEASED_ARRIVED = 'RELEASED_ARRIVED',
        RELEASED_UNLOADED = 'RELEASED_UNLOADED',
        ON_FILE = 'ON_FILE',
        READY_FOR_DISPATCH = 'READY_FOR_DISPATCH',
        DISPATCHED_PLANNED = 'DISPATCHED_PLANNED',
        DISPATCHED_ASSIGNED = 'DISPATCHED_ASSIGNED',
        DISPATCHED_CONFIRMED = 'DISPATCHED_CONFIRMED',
        IN_PROCESS_PICKUP = 'IN_PROCESS_PICKUP',
        COMPLETED_PICKUP = 'COMPLETED_PICKUP',
        IN_PROCESS_DELIVERY = 'IN_PROCESS_DELIVERY',
        COMPLETED_DELIVERY = 'COMPLETED_DELIVERY',
        IN_PROCESS_RETURN = 'IN_PROCESS_RETURN',
        COMPLETED = 'COMPLETED',
        CANCELLED = 'CANCELLED',
    }
}

